import { loginRequest } from '../authConfig';

export function handleLogin(instance) {
  instance.loginRedirect({ ...loginRequest, redirectUri: `${window.location.origin}/dashboard` }).catch((e) => {
    console.error(e);
  });
}

export async function handleLogout(instance) {
    
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(";").forEach((c) => {
      document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    setTimeout(() => {
      instance.logoutRedirect({
          postLogoutRedirectUri: '/',
      }).catch((e) => {
          console.error(e);
      });
  }, 100);
}
